import axios from 'axios';

function getRoot () {
    if(location.host=='www.qzg001.com'||location.host=='www.haierbx.net'||location.host=='www.zonemio.com'||location.host=='qzg001.com'||location.host=='haierbx.net'||location.host=='zonemio.com'){
        return 'https://partner.haierbx.net'
    }else{
        // return 'http://10.128.15.6:7001'
        return 'http://p2-h5.haierbx.net'
    }
}
var _fetch = {}
_fetch.install = (Vue,option)=>{
    Vue.prototype.$fetch = function (url,options={}) {
        // url = root+url;
        return new Promise((resolve,reject)=>{
            axios(url+'.all',{
                mode:'cors',
                baseURL:getRoot(),
                ...options,
                headers:{
                    'Content-Type':'application/x-www-form-urlencoded',
                    ...(options&&options.headers)
                }
            }).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err)
            })
        })
    }
}
export default _fetch;


// WEBPACK FOOTER //
// ./src/common/fetch.js